import {EntityModel} from "@fedeltapointofsale/data-client";
import {OrderProcessorData} from "./order-processor.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class OrderProcessorEntityModel extends EntityModel<OrderProcessorData<any>> {

    constructor(injector: Injector) {
        super(injector, OrderProcessorData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
